"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WanikaniStatus = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _kyouElements = require("kyou-elements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject7() {
  const data = _taggedTemplateLiteral(["\n  display: inline-block;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 5px;\n  padding: 5px;\n  margin: 5px;\n  font-size: 18px;\n  line-height: 18px;\n\n  @media only screen and (min-width: 1600px) {\n    border-radius: 5px;\n    padding: 10px;\n    font-size: 30px;\n    line-height: 30px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  const data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n  font-family: \"Muli\", sans-serif;\n  color: ", ";\n  font-size: 20px;\n  display: inline-block;\n  margin-left: 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const Container = _styledComponents.default.div(_templateObject());

const SummaryBar = _styledComponents.default.div(_templateObject2());

const Stat = _styledComponents.default.span(_templateObject3(), _kyouElements.colors.WHITE);

const LessonsStat = (0, _styledComponents.default)(Stat)(_templateObject4(), _kyouElements.colors.WANI_PINK);
const ReviewsStat = (0, _styledComponents.default)(Stat)(_templateObject5(), _kyouElements.colors.WANI_BLUE);

const KanjiBar = _styledComponents.default.div(_templateObject6());

const Kanji = _styledComponents.default.span(_templateObject7(), _kyouElements.colors.WHITE, (_ref) => {
  let {
    passed
  } = _ref;
  return passed ? _kyouElements.colors.WANI_PINK : "none";
});

const WanikaniStatus = (_ref2) => {
  let {
    isLoading,
    levelStatus
  } = _ref2;

  const renderKanji = kanji => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: kanji.subjectId
    }, /*#__PURE__*/_react.default.createElement(Kanji, {
      passed: kanji.passed
    }, kanji.characters));
  };

  const renderKanjiBar = () => {
    const {
      passedKanji,
      remainingKanji
    } = levelStatus;
    return /*#__PURE__*/_react.default.createElement(KanjiBar, null, passedKanji.map(kanji => renderKanji(kanji)), remainingKanji.map(kanji => renderKanji(kanji)));
  };

  const renderContent = () => {
    const {
      level,
      lessons,
      reviews,
      passedKanji,
      levelKanji
    } = levelStatus;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SummaryBar, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_kyouElements.Title, null, "Level ".concat(level))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Stat, null, "".concat(passedKanji.length, " of ").concat(levelKanji.length, " kanji passed")), /*#__PURE__*/_react.default.createElement(LessonsStat, null, "".concat(lessons, " lessons")), /*#__PURE__*/_react.default.createElement(ReviewsStat, null, "".concat(reviews, " reviews")))), renderKanjiBar());
  };

  return /*#__PURE__*/_react.default.createElement(Container, null, !isLoading && renderContent());
};

exports.WanikaniStatus = WanikaniStatus;
WanikaniStatus.propTypes = {
  isLoading: _propTypes.default.bool.isRequired,
  levelStatus: _propTypes.default.shape({
    level: _propTypes.default.number,
    lessons: _propTypes.default.number,
    reviews: _propTypes.default.number,
    levelKanji: _propTypes.default.array,
    passedKanji: _propTypes.default.array,
    remainingKanji: _propTypes.default.array
  })
};